module.exports = __webpack_public_path__ + "static/img/shangpin2.50488a49.png";